import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex, Popover, PopoverContent, PopoverTrigger, useColorMode } from '@chakra-ui/react';
import { Typography } from '../../../Typography';
import { theme } from '../../../../modules/theme';
import { genIconComponent } from '../../index';
export const MediaMenu = ({ menu }) => {
    const { colorMode } = useColorMode();
    return (_jsx(Popover, { placement: "top-end", trigger: "hover", strategy: 'fixed', children: ({ isOpen }) => (_jsxs(_Fragment, { children: [_jsx(PopoverTrigger, { children: _jsx(Flex, { color: isOpen
                            ? theme.colors[colorMode].text.secondary
                            : theme.colors[colorMode].text.tertiary, "data-analytics-id": menu['data-analytics-id'], alignItems: "center", sx: {
                            '.svg-image': {
                                WebkitMaskImage: `url(${menu.icon})`,
                                WebkitMaskSize: 'contain',
                                WebkitMaskPosition: 'center',
                                WebkitMaskRepeat: 'no-repeat',
                                flexShrink: 0,
                                bgColor: isOpen
                                    ? theme.colors[colorMode].text.secondary
                                    : theme.colors[colorMode].text.tertiary,
                                '&:hover': {
                                    bgColor: theme.colors[colorMode].text.secondary,
                                },
                            },
                            '.svg-icon': {
                                color: isOpen
                                    ? theme.colors[colorMode].text.secondary
                                    : theme.colors[colorMode].text.tertiary,
                                '&:hover': {
                                    color: theme.colors[colorMode].text.secondary,
                                },
                            },
                        }, children: genIconComponent(menu.icon) }) }), _jsx(PopoverContent, { py: theme.sizes['2'], bg: theme.colors[colorMode].layer[3].default, borderRadius: theme.sizes['2'], overflow: "hidden", border: "none", boxShadow: "none", children: _jsx(Flex, { flexDirection: 'column', children: menu.children?.map((it) => (_jsx(Flex, { as: "a", href: it.href, target: it.target || '_blank', "data-analytics-id": it['data-analytics-id'] || '', px: theme.sizes['4'], py: theme.sizes['3'], w: "100%", color: theme.colors[colorMode].text.secondary, bg: theme.colors[colorMode].layer[3].default, _hover: {
                                bg: theme.colors[colorMode].layer[3].hover,
                            }, sx: {
                                '.svg-image': {
                                    WebkitMaskImage: `url(${it.icon})`,
                                    WebkitMaskSize: 'contain',
                                    flexShrink: 0,
                                    bgColor: theme.colors[colorMode].text.tertiary,
                                    '&:hover': {
                                        bgColor: theme.colors[colorMode].text.secondary,
                                    },
                                },
                                '.svg-icon': {
                                    color: theme.colors[colorMode].text.tertiary,
                                    '&:hover': {
                                        color: theme.colors[colorMode].text.secondary,
                                    },
                                },
                            }, children: _jsxs(Flex, { alignItems: "center", children: [genIconComponent(it.icon), _jsx(Typography, { variant: "label", size: "md", ml: theme.sizes['2'], children: it.name })] }) }, it.name))) }) })] })) }));
};
